export default __webpack_public_path__ + "static/media/eye.c5580c00.png";